export default "__VITE_ASSET__8ATrKtmB__"